import { Units } from "../../../MealTrack/MTAPITypes";
export var MacroNutrientText;
(function (MacroNutrientText) {
    MacroNutrientText["PER_SERVING"] = "per serving";
    MacroNutrientText["CARBS"] = "carbs";
    MacroNutrientText["CAL"] = "cal";
    MacroNutrientText["FAT"] = "fat";
    MacroNutrientText["PROTEIN"] = "protein";
    MacroNutrientText["FIBER"] = "fiber";
    MacroNutrientText["SUGAR"] = "sugar";
})(MacroNutrientText || (MacroNutrientText = {}));
export const UnitDisplayRecord = {
    [Units.Gram]: "g",
};
